// Semantic tone shared across badges/alerts/cells. Presentational only — no business
// meaning is inferred here; callers map domain state (e.g. aging bucket, document status)
// to a tone.
export type Tone = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

export const TONE_CLASSES: Record<Tone, string> = {
  neutral: 'bg-surface-muted text-fg-muted',
  primary: 'bg-primary/10 text-primary',
  success: 'bg-success/15 text-success',
  warning: 'bg-warning/15 text-warning',
  danger: 'bg-danger/15 text-danger',
  info: 'bg-info/10 text-info',
};

export const TONE_SOLID_CLASSES: Record<Tone, string> = {
  neutral: 'bg-surface-muted text-fg',
  primary: 'bg-primary text-primary-fg',
  success: 'bg-success text-primary-fg',
  warning: 'bg-warning text-primary-fg',
  danger: 'bg-danger text-primary-fg',
  info: 'bg-info text-primary-fg',
};
